module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="generalAlarm-slider"><dl v-show="model.modelError"><dd><p class="error">ERROR! {{ model.modelError }}</p></dd></dl><label for="general-alarm-enabled">{{ tc(\'ControlHomeAlerts\', \'General Alarm Input:\') }}</label><div class="input" id="general-alarm-enabled"><defa-radio-strip v-model="generalAlarmValue" :options="generalAlarmOptions" v-bind:class="{ errorState: model.alarmMask === null}" v-on:input="save($event, \'alarmMask\')"></div><dl v-show="model.alarmMaskError"><dd><p class="error">ERROR! {{ model.alarmMaskError }}</p></dd></dl></div>';
}
return __p;
};
